import { render, staticRenderFns } from "./appCompose.vue?vue&type=template&id=272476b5&scoped=true"
import script from "./appCompose.vue?vue&type=script&lang=js"
export * from "./appCompose.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=272476b5&prod&lang=scss&scoped=true&external"
import style1 from "./appCompose.vue?vue&type=style&index=1&id=272476b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272476b5",
  null
  
)

export default component.exports